import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styled, { keyframes } from 'styled-components'
import colorLogo from '../../../assets/images/color-logo.svg'
import Logomark from '../layout/logomark.component'

const animateColor = keyframes`
    from { background-color: white; }
    to { background-color: ; }
`

const StyledBackdrop = styled.div`
	position: fixed;
	left: 0;
	top: 0;
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${props =>
		props.transparent ? 'rgba(0, 0, 0, 0.5)' : '#FFF'};
	z-index: 3;

	.logo-container {
		display: flex;
		align-items: center;

		.orange,
		.blue,
		.yellow {
			animation: ${animateColor} 0.6s infinite;
			animation-direction: alternate;
		}
	}
`

class MainLoaderComponent extends PureComponent {
	constructor(props) {
		super(props)
		this.props = props
		this.state = {
			fade: false
		}
	}

	removeLoader = () => {
		this.setState({ fade: true }, () => {
			this.setState({
				fade: false
			})
		})
	}

	componentWillReceiveProps(nextProps) {
		this.props.showLoader !== nextProps.showLoader && this.removeLoader()
	}

	getClassName = () => `animated ${this.state.fade ? 'fadeOut' : 'fadeIn'}`

	render() {
		const { showLoader } = this.props
		return showLoader ? (
			<StyledBackdrop
				transparent={this.props.transparent}
				className={this.getClassName()}>
				<div className="logo-container">
					<Logomark />
					<img src={colorLogo} alt="Logomarca Muviflex" />
				</div>
			</StyledBackdrop>
		) : null
	}
}

const mapStoreToProps = store => {
	const { site } = store
	return {
		...site
	}
}

const MainLoader = connect(
	mapStoreToProps,
	null
)(MainLoaderComponent)

export default MainLoader
